export const AjaxCart = function () {

    const $body = $('body');

    $body.on('submit', 'form.cart', function (e) {
        const $form = $(this);
        let $productWrapper = $form.parents('.single-product-page');

        e.preventDefault();

        if ($productWrapper.length === 0) {
            $productWrapper = $form.parents('.product-quick-view');
        }

        if ($productWrapper.hasClass('product-type-external') || $productWrapper.hasClass('product-type-zakeke') || $productWrapper.hasClass('product-type-gift-card')) {
            return;
        }

        const $thisbutton = $form.find('.single_add_to_cart_button');
        let data = $form.serialize();

        data += '&action=wbs_add_to_cart';

        if ($thisbutton.val()) {
            data += '&add-to-cart=' + $thisbutton.val();
        }

        $thisbutton.removeClass('added not-added');
        $thisbutton.addClass('loading');

        $body.trigger('adding_to_cart', [
            $thisbutton,
            data
        ]);


        $.ajax({
            url: wbs_ajax_data.ajaxUrl,
            data: data,
            method: 'POST',
            success: function (response) {

                if (!response) {
                    return;
                }

                console.log(response.notices);

                const this_page = window.location.toString();

                this_page.replace('add-to-cart', 'added-to-cart');

                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }


                $thisbutton.removeClass('loading');

                const fragments = response.fragments;
                const cart_hash = response.cart_hash;

                // Block fragments class
                if (fragments) {
                    $.each(fragments, function (key) {
                        $(key).addClass('updating');
                    });
                }

                // Replace fragments
                if (fragments) {
                    $.each(fragments, function (key, value) {
                        $(key).replaceWith(value);
                    });
                }

                // Show notices
                const $noticeWrapper = $('.woocommerce-notices-wrapper');
                $noticeWrapper.empty();



                // Changes button classes
                $thisbutton.addClass('added');
                // Trigger event so themes can refresh other areas
                $body.trigger('added_to_cart', [
                    fragments,
                    cart_hash,
                    $thisbutton
                ]);


            },
            error: function () {
                console.log('ajax adding to cart error');
            },
            complete: function () {
            }
        });

    });

};